const reducer = (state, { restrictedProductGroups }) => ({
  ...state,
  restrictedProductGroups,
});

export default reducer;
